import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import "./styles/App.css"
import { ModalsProvider } from '@mantine/modals';
import history from "./history";
import {AppShell, Grid, MantineProvider, Navbar,} from '@mantine/core';
import {Header} from './components/Socket';
import { Colors } from './Constants/Colors';
ReactDOM.render(
            <MantineProvider
                theme={{
                    // Override any other properties from default theme
                    fontFamily: 'Open Sans, sans serif',
                    spacing: { xs: 15, sm: 20, md: 25, lg: 30, xl: 40 },
                    breakpoints: {
                        xs: 576,
                        sm: 768,
                        md: 992,
                        lg: 1200,
                        xl: 1400
                    },
                }}
            >
                <ModalsProvider>
                <BrowserRouter history={history}>
                <Header />
                <AppShell
                    padding="md"
                    styles={(theme) => ({
                        main: { backgroundColor: Colors.Page },
                    })}
                >
                  <App />
                </AppShell>
                </BrowserRouter>
                </ModalsProvider>
            </MantineProvider>,
    document.getElementById("root")
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
